import { useQuery } from '@tanstack/react-query'
import { queries, useOvens } from '@tovala/browser-apis-combinedapi'

export const useOvenChannel = ({ userID }: { userID: number | undefined }) => {
  const { data: userOvens = [], isPending: isLoadingOvens } = useOvens({
    userID,
  })
  const userOvenSerialNumber = userOvens[0]?.tovala.serial
  const { data: ovenPurchaseChannel, isPending: isLoadingOvenPurchaseChannel } =
    useQuery({
      ...queries.ovens.purchaseChannel({ serialNumber: userOvenSerialNumber }),
      retry: false,
    })

  return {
    data: {
      ovenChannel: ovenPurchaseChannel?.channel,
      ovenSubChannel: ovenPurchaseChannel?.subChannel,
    },
    isPending: isLoadingOvens || isLoadingOvenPurchaseChannel,
  }
}
